<template>
  <div class="category-item">
    <div class="category-item--head">
      <div class="category-item--title">
        <Checkbox
            v-model="parentCategory"
            :inputId="`amenity${category.code}`"
            :value="category.code"
            @update:modelValue="selectParentCategory()"
        />
        <label :for="`amenity${category.code}`">{{ category.name }}</label>
      </div>
      <div class="category-item--toggle">
        <div class="category-item--toggle-btn" @click="toggleSubCategory">
          <span class="icon icon-chevron-down"></span>
        </div>
      </div>
    </div>
    <div class="subcategories-list" v-if="category.subcategories.length" v-show="visibleSubCategory">
      <div class="category-item" v-for="subCategory in existedSubCategories(category.subcategories)">
        <div class="category-item--head">
          <div class="category-item--title">
            <Checkbox
                v-model="selectedCategories"
                :inputId="`amenity${subCategory.code}`"
                :value="subCategory.code"
                :disabled="subCategory.total === 0"
                @update:modelValue="selectCategory()"
            />
            <label :for="`category-item${subCategory.code}`">{{ subCategory.name }}</label>
          </div>
          <span class="category-item--count">{{subCategory.total}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Checkbox from "primevue/checkbox";
import {useSearchStore} from "~/store/search";
import { useRoute } from "vue-router";
const route = useRoute();
const searchStore = useSearchStore();
const props = defineProps({category: {type: Object, required: true}});
const emit = defineEmits(['update']);
const totalByCategory = computed(() => searchStore.totalByCategory);
const selectedCategories = ref<Array<string>>([])
const parentCategory = ref<Array<string>>([])
const category = computed(() => props.category)
const visibleSubCategory = ref(false);
const query = computed(() => route.query);

function selectCategory() {
  emit('update', selectedCategories.value);
}

const selectParentCategory = () => {
  if (parentCategory.value.length) {
    const subCategories = [] as Array<string>
    (category.value as any).subcategories.forEach((subCategory: any) => {
      subCategories.push(subCategory.code)
    })
    selectedCategories.value = [...parentCategory.value, ...subCategories]
  } else {
    selectedCategories.value = []
  }

  selectCategory()
}

const existedSubCategories = (subCategory: any) => {
  let result = subCategory
  result?.map((obj: any) => {
    if (totalByCategory.value.length) {
      let existedCategory = totalByCategory.value.find((item: any) => {
        return obj.code === item.code
      })

      if (existedCategory !== undefined) {
        obj.total = (existedCategory as any).total
      } else {
        obj.total = 0
      }
    } else {
      obj.total = 0
    }

    return obj
  })

  return result
}

const toggleSubCategory = () => {
  visibleSubCategory.value = !visibleSubCategory.value
}

const checkSelectedCategories = () => {
  const categories = (query.value?.categories as string)?.split(',') || []
  selectedCategories.value = (query.value?.categories as string)?.split(',') || []
  parentCategory.value = categories.includes((category.value as any).code) ? [(category.value as any).code] : []
}

onMounted(() => {
  checkSelectedCategories()
})
</script>
